import React from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";
import { renderContent } from "../../utilities/renderContent";
import CtaButton from "../elements/CtaButton";

export default function RightImageText({ data }) {
  const {
    image,
    text,
    backgroundColor,
    callToActionButtonLink,
    callToActionButtonText,
    badgeImage,
  } = data;
  return (
    <section
      className={`Product hds-container bg-${backgroundColor} hds-text-color z-10 my-8`}
    >
      <div
        className={`w-full md:flex text-left hds-transition hide-variants flex-row-reverse ${
          backgroundColor === "dark-blue" ? "text-white" : ""
        }`}
      >
        <div
          className={`w-full md:w-2/3 hds-transition fade-item fade-left is-showing flex justify-end`}
        >
          <Image
            class="object-cover object-center h-full max-w-full w-full"
            image={getImage(image)}
            alt={image.alt ? image.alt : ""}
          />
          {badgeImage && (
            <Image
              className="h-14 md:h-32 w-14 md:w-32 bottom-calc left-calc"
              style={{ position: "absolute" }}
              image={getImage(badgeImage)}
              alt={badgeImage.alt ? badgeImage.alt : ""}
            />
          )}
        </div>

        <div
          className={`md:w-1/3 p-6 md:p-20 self-center max-w-xl hds-transition fade-item fade-right is-showing lit-rit-text`}
        >
          <div className="pb-4" dangerouslySetInnerHTML={renderContent(text)} />
          {callToActionButtonLink && callToActionButtonText && (
            <CtaButton
              link={callToActionButtonLink}
              text={callToActionButtonText}
            />
          )}
        </div>
      </div>
    </section>
  );
}

export const query = graphql`
  fragment RightImageTextComponent on DatoCmsRightImageText {
    internal {
      type
    }
    id
    text
    backgroundColor
    imageSize
    image {
      alt
      gatsbyImageData
    }
    callToActionButtonLink
    callToActionButtonText
    badgeImage {
      alt
      gatsbyImageData
    }
  }
`;
